import { render } from "./GeneratePersonas.vue?vue&type=template&id=429c87c5&scoped=true"
import script from "./GeneratePersonas.vue?vue&type=script&lang=js"
export * from "./GeneratePersonas.vue?vue&type=script&lang=js"

import "./GeneratePersonas.vue?vue&type=style&index=0&id=429c87c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429c87c5"]])

export default __exports__